/* eslint-disable import/no-cycle */
import { selectRootSliceFCCJ } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

export const selectThisSlice = state => { 
  const slice = selectRootSliceFCCJ(state);
  if (slice[ROOT_SLICE]) { 
    return slice[ROOT_SLICE];
  }

  // else assume state is already lines aggs.
  return state;
};

export const selectCustomer = (state) => { 
  const slice = selectThisSlice(state);
	const { customer } = slice;
	return customer;
}

export default {
	selectCustomer,
};
